import styled from 'styled-components';

import * as text from '@/components/general/TextStyles';

export const Container = styled.article`
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 60px;

  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    flex-direction: column-reverse;
  }
`;

export const TemplateBox = styled.div`
  max-width: 542px;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    max-width: ${(props) =>
      `calc(542px - (${props.theme.breakpoints.lg}px - 100vw))`};
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 24px;
    max-width: none;
  }
`;

export const IconBox = styled.div`
  margin-bottom: 20px;
  height: 70px;
  display: flex;
  align-items: center;

  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    height: 50px;
    margin-bottom: 15px;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    height: 36px;
  }
`;

export const PlusBox = styled.div`
  height: calc(24 / 70 * 100%);
  aspect-ratio: 1/1;
  position: relative;
  margin: 0 14px;

  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    margin: 0 12px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    margin: 0 10px;
  }

  & > span {
    background-color: #d4d4d4;
    border-radius: 8px;
  }
  & > span:first-child {
    position: absolute;
    height: 100%;
    aspect-ratio: 1/6;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  & > span:last-child {
    position: absolute;
    width: 100%;
    aspect-ratio: 6/1;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }
`;

export const TitleBox = styled.div`
  margin-bottom: 20px;
`;

export const Title = styled.h2`
  ${text.FS42_LG}
`;

export const TagsBox = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
  margin-bottom: 30px;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    flex-wrap: wrap;
    row-gap: 10px;
  }
`;

export const DescriptionBox = styled.div`
  margin-bottom: 40px;

  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    margin-bottom: 30px;
  }
`;

export const Description = styled.p`
  ${text.FS17}
`;

export const ButtonBox = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  row-gap: 20px;
  column-gap: 15px;

  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    flex-wrap: nowrap;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    column-gap: 10px;
    flex-wrap: wrap;
  }

  & button,
  a {
    height: 36px;
  }
`;

export const SmallButtonBox = styled(ButtonBox)``;

export const ImageBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 637px;
  aspect-ratio: 1/1.48;
  background-color: ${(props) => props.theme.colors.offGreen};
  border-radius: 32px;
  padding: 45px 0;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    height: calc(550px - (1024px - 100vw) / 4);
  }
  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    width: 100%;
    height: 400px;
    padding: 20px 0;
    border-radius: 16px;
  }
`;

export const ImageBorderBox = styled.div`
  border-radius: 22px;
  border: 3px solid ${(props) => props.theme.colors.black};
  height: 100%;
  aspect-ratio: 0.46/1;
  overflow: hidden;
  box-sizing: content-box;

  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    border-radius: 16px;
  }
`;
